import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape, FormattedHTMLMessage } from 'react-intl';
import { levels } from './../../config';
// translate
import messages from './messages';

class Status extends Component {
  constructor(props) {
    super(props);

    this.complete = false;
  }

  componentWillMount() {
    this.initData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.balance !== this.props.balance) {
      this.initData(nextProps);
    }
  }

  shouldComponentUpdate(nextProps) {
    return nextProps.balance !== this.props.balance;
  }

  initData(props) {
    this.currentLevel = this.detectCurrentLevel(props.balance);
    this.nextLevel = this.detectNextLevel();
  }

  detectCurrentLevel(balance) {
    let level = '';

    // eslint-disable-next-line no-restricted-syntax
    for (const [key, value] of levels.entries()) {
      const maxValue = Array.from(value).pop();
      if (balance < maxValue) {
        level = key;
        break;
      }
    }

    if (level.length === 0) {
      this.complete = true;
    }

    return level;
  }

  detectNextLevel() {
    const levelKeys = Array.from(levels.keys());
    const levelIdx = levelKeys.indexOf(this.currentLevel);

    return levelKeys[levelIdx + 1];
  }

  currentMinValue() {
    const values = Array.from(levels.get(this.currentLevel));
    return values[0];
  }

  currentMaxValue() {
    const values = Array.from(levels.get(this.currentLevel));
    return values.pop();
  }

  currentValueInPercent() {
    const { balance } = this.props;
    const minValue = this.currentMinValue();
    const maxValue = this.currentMaxValue();

    return (balance - minValue) / ((maxValue - minValue) / 100);
  }

  remainingToMaxValue() {
    return this.currentMaxValue() - this.props.balance;
  }

  renderProgress() {
    const items = [];
    levels.get(this.currentLevel).forEach(value =>
      items.push(
        <span key={`l-${value}`} className="level-progress-legend">
          ${value.toLocaleString()}
        </span>,
      ),
    );

    return items;
  }

  render() {
    const { intl } = this.props;

    if (this.complete) {
      return null;
    }

    return (
      <div className="container-fluid dashboard-progress">
        <div className="row">
          <div className="container">
            <div className="row">
              <div className="col-md-4">
                <p className="dashpoard-title">
                  {intl.formatMessage(messages.currentStatus)}
                </p>
                <span className={`status-name ${this.currentLevel}`}>
                  {this.currentLevel}
                </span>
              </div>

              <div className="col-md-4">
                <p className="dashpoard-title">
                  <FormattedHTMLMessage
                    {...Object.assign(messages.progressToLevel, {
                      values: { nextLevel: this.nextLevel },
                    })}
                  />
                </p>

                <span className="level-progress-wrap">
                  <span className="level-progress-wrap-inner">
                    <span
                      className="level-progress-bar"
                      style={{ width: `${this.currentValueInPercent()}%` }}
                    />
                  </span>
                  {this.renderProgress()}
                </span>
              </div>

              <div className="col-md-4">
                <p className="dashpoard-title">
                  <FormattedHTMLMessage
                    {...Object.assign(messages.remainingToLevel, {
                      values: { nextLevel: this.nextLevel },
                    })}
                  />
                </p>
                <span className={`status-name ${this.nextLevel}`}>
                  ${this.remainingToMaxValue()}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Status.propTypes = {
  intl: intlShape.isRequired,
  balance: PropTypes.number.isRequired,
};

export default injectIntl(Status);



// WEBPACK FOOTER //
// ./src/components/Status/index.js